import Cookies from 'universal-cookie';

// Nom du cookie portant le jeton d'accès. Dérivé du cookie utilisateur pour
// éviter une variable d'environnement supplémentaire à déployer.
export const TOKEN_COOKIE = `${process.env.REACT_APP_USER_COOKIE}_token`;

const Api = (opt) => {
  const cookies = new Cookies();
  const userData = cookies.get(process.env.REACT_APP_USER_COOKIE) || {};
  const access_token = cookies.get(TOKEN_COOKIE);
  let endpoint = opt.endpoint;

  // 
  // ─── CREATION DU HEADER NECESSAIRE A LA REQUETE ───────────────────────────────────────
  //
  let myHeaders = new Headers();
  if (!opt.removeHeader) {
    myHeaders.append("Content-Type", "application/json");
  }

  // 
  // ─── AUTHENTIFICATION PAR EN-TETE ───────────────────────────────────────
  // L'API et le front sont sur deux domaines distincts : le cookie httpOnly
  // posé par l'API est un cookie tiers, que Safari iOS bloque systématiquement.
  // On transmet donc le jeton en en-tête, ce que authenticate_jwt sait lire.
  // `credentials: 'include'` reste actif : là où le cookie passe, il sert de
  // second canal sans qu'on ait à choisir.
  //
  if (access_token) {
    myHeaders.append("Authorization", `Bearer ${access_token}`);
  }

  // 
  // ─── DEFINITION DE LA METHODE A UTILISER ───────────────────────────────────────
  //
  let method = opt.method || 'POST'

  // 
  // ─── AJOUT DES OPTIONS DANS LE HEADER ───────────────────────────────────────
  //
  let requestOptions = {
    method,
    headers: myHeaders,
    redirect: 'follow',
    credentials: 'include'
  }

  // 
  // ─── AJOUT DES DONNEES SOUS FORME DE JSON STRINGIFY ───────────────────────────────────────
  //
  if (['POST', 'PUT', 'DELETE'].includes(method)) {
    const data = opt.data || {};
    if (userData) {
      data['user_id'] = userData.user_id
    }
    requestOptions = { ...requestOptions, body: opt.removeHeader ? data : JSON.stringify(data) }
  } else {
    // Automatically add query params
    if (userData) endpoint += `?user_id=${userData.user_id}`;
    else endpoint += `?`;
    if (opt.query) {
      Object.entries(opt.query).map(([key, value]) => {
        endpoint += `&${key}=${value}`
      })
    }
  }

  // 
  // ─── REQUETE A L'API ───────────────────────────────────────
  //
  return fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, requestOptions)
    .then(response => response.json())
    .then(result => result)
    .catch(error => console.log('error', error));
}

export default Api;